module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_33.ab5d18f2.jpg";